import Charts from './components/Charts.vue'
import ChartsSsrn from './components/ChartsSsrn.vue'
import ChartsArxiv from './components/ChartsArxiv.vue'
import ChartsTotal from './components/ChartsTotal.vue'
import Visualizations from './components/Visualizations.vue'

export default [
    {title: 'Visualizations',
    path: '/Visualizations',
    component: Visualizations,
    show_navbar: false},
    {title: 'Media',
    path: '/',
    component: Charts,
    show_navbar: true},
    {title: 'SSRN',
    path: '/ChartsSsrn',
    component: ChartsSsrn,
    show_navbar: true},
    {title: 'arXiv',
    path: '/ChartsArxiv',
    component: ChartsArxiv,
    show_navbar: true},
    {title: 'Common terms',
    path: '/ChartsTotal',
    component: ChartsTotal,
    show_navbar: true},
]


// WEBPACK FOOTER //
// ./src/routes.js